import $ from 'jquery';
import rimg from '@pixelunion/rimg-shopify';
import EventHandler from '@pixelunion/events';
import { trapFocus, removeTrapFocus, focusable } from '@shopify/theme-a11y';
import fitvids from 'fitvids';
import $script from 'scriptjs';
import ShopifySurfacePickUp from '@pixelunion/shopify-surface-pick-up';
import layout from '../utils/layout';
import PaymentTerms from '../helpers/PaymentTerms';
import ProductGallery from './ProductGallery';
import Modal from './Modal';

export default class Product {
  constructor(theme) {
    this.theme = theme;
    this.$body = $(document.body);
    this.$window = $(window);
    this.$document = $(document);
    this.$productContainer = $('[data-product-list]');
    this.$scripts = $('[data-scripts]');

    this.unitPrice = document.querySelectorAll('[data-unit-price]');

    this.cachedProductSelector = 'script[type="application/vnd.vogue.product+html"]';
    this.extendedOpenSelector = '[data-product-extended-open]';
    this.extendedCloseSelector = '[data-product-extended-close]';
    this.extendedMobileSelector = '[data-product-extended-mobile]';
    this.productSelector = '[data-product-id]';
    this.productHeaderSelector = '.product-details-header';
    this.products = [];
    this.events = new EventHandler();

    this.galleryEnableVideoLooping = this.$productContainer.length
      && this.$productContainer[0].dataset.galleryEnableVideoLooping === 'true';

    // Sidebar settings
    this.hasSidebar = window.Theme.hasSidebar;
    this.gridSpacing = parseInt(window.Theme.gridSpacing, 10) || 0;
    this.sidebarWidth = 300;
    this.enableHistory = true;

    if (window.Shopify && window.Shopify.preview_host) {
      this.enableHistory = false;
    }

    if (this.$productContainer.length) {
      $script(this.$scripts.data('shopify-api-url'), () => {
        this._bindEvents();
      });

      this._addProducts(this.productSelector, false);
      this._fetchProducts(1);
    }

    if ($('[data-single-product]').length) {
      this.$body.addClass('product-single');
    } else {
      this.$body.removeClass('product-single');
    }

    this.positionTicking = false;
    this.positionTick = this._positionTick.bind(this);

    this._updateProductPositions();
    this.$window.on('scroll.vogue-product', this.positionTick);
    this.$window.on('resize.vogue-product', this.positionTick);

    if (Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }
  }

  remove() {
    if (this.$extendedProduct && this.$extendedProduct.length) {
      this._closeExtendedDetails(this.$extendedProduct);
    }

    this.events.unregisterAll();
    this.$body.off('.vogue-product');
    this.$window.off('.vogue-product');
    this.$window.off('.vogue-extended-resize');
  }

  /**
   * Load products from our in-page cache.
   */
  _fetchProducts(limit) {
    $(this.cachedProductSelector)
      .slice(0, limit)
      .each((index, el) => this._addProducts(el.innerHTML))
      .remove();
  }

  _pauseGalleries(exclude = null) {
    this.products
      .filter(product => product.productGallery !== exclude)
      .forEach(product => product.productGallery.pause());
  }

  _generateProductGallery(el, options = {}) {
    return new ProductGallery(el, {
      enableVideoLooping: this.galleryEnableVideoLooping,
      pauseOtherGalleries: currentGallery => this._pauseGalleries(currentGallery),
      ...options,
    });
  }

  /**
   * Register products with our scroll effects handler.
   */
  _addProducts(products, addToPage = true) {
    $(products).each((index, el) => {
      const $el = $(el);

      // Add to the page
      if (addToPage) {
        this.$productContainer
          .find('.product:last')
          .after($el);

        $el.trigger('theme:rimg:watch');

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      }

      // Surface Pick Up
      const surfacePickUpElement = el.querySelector('[data-surface-pick-up]');
      const currentProductForm = el.querySelector('[data-product-variants]');

      const { productTitle, variantId } = currentProductForm.dataset;

      const surfacePickUp = new ShopifySurfacePickUp(surfacePickUpElement);
      surfacePickUp.load(variantId);

      surfacePickUp.onModalRequest(contents => {
        this.modal = new Modal(
          {
            el: document.querySelector('[data-modal-id="surface-pick-up"]'),
            callbacks: {
              onOpen: ({ modal }) => {
                const modalHeader = modal.querySelector('[data-modal-header]');
                const modalContents = modal.querySelector('[data-modal-contents]');
                const variant = this._getSelectedProductVariant($el);


                if (productTitle && variant.title) {
                  if (variant.title === 'Default Title') {
                    modalHeader.innerHTML = `<h2 class="surface-pick-up-modal__header">${productTitle}</h2>`;
                  } else {
                    modalHeader.innerHTML = `<h2 class="surface-pick-up-modal__header">${productTitle}</h2><span class="surface-pick-up-modal__subtitle">${variant.title}</span>`;
                  }
                }

                modalContents.innerHTML = contents;
              },
            },
          },
          {
            reposition: false,
          },
        );
        this.modal.open();
        this.modal.showModal();
      });

      const $gallery = $el.find('.product-gallery');
      const originalGallery = $gallery[0].cloneNode(true);
      const productGallery = this._generateProductGallery($el[0]);

      const paymentTerms = new PaymentTerms(el);

      // Cache elements so we can access them quickly in the scroll handler
      this.products.push({
        $el,
        $body: $el.find('.product-body'),
        $details: $el.find('.product-details'),
        $gallery,
        $mobileHeader: $el.find('.product-details-header-mobile'),
        productGallery,
        originalGallery,
        paymentTerms,
        surfacePickUp,
      });
    });

    // Make any videos responsive
    fitvids('.product-description-full.rte');
  }

  _bindEvents() {
    // Load in new products as we scroll down the page
    this.$window.on('scroll.vogue-product', () => {
      if (this._isMobile() || this._isSingleSidebarTablet(false) || this._isSingleSidebarTablet(true)) return;

      const percent = this.$window.scrollTop() / (this.$document.height() - this.$window.height());

      if (percent < 0.6) return;
      this._fetchProducts(4);
    });

    this.$window.on('shopify:section:unload', () => {
      if (this.$extendedProduct && this.$extendedProduct.length) {
        this._closeExtendedDetails(this.$extendedProduct);
      }
    });

    // Scroll down to the product details on mobile
    this.$body.on('click.vogue-product', this.extendedMobileSelector, (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      const $el = $target.parents(this.productSelector).find('.product-details');

      this._ensureElementInViewport($el[0]);
    });

    // Open the extended details panel
    this.$body.on('click.vogue-product', this.extendedOpenSelector, (event) => {
      event.preventDefault();
      const $target = $(event.currentTarget);
      this.$extendedProduct = $target.parents(this.productSelector);
      this._openExtendedDetails(this.$extendedProduct);

      const newEvent = new CustomEvent('vogue:loadRecommended', {
        detail: { productElement: this.$extendedProduct[0] },
      });
      window.dispatchEvent(newEvent);
    });

    // Close the extended details panel
    this.$body.on('click.vogue-product', this.extendedCloseSelector, (event) => {
      event.preventDefault();
      this._closeExtendedDetails(this.$extendedProduct);
    });

    // Close the extended details panel when resizing down to mobile
    this.$window.on('resize.vogue-product', () => {
      if (this.$extendedProduct && (this._isMobile() || this._isSingleSidebarTablet(false) || this._isSingleSidebar(true))) {
        this._closeExtendedDetails(this.$extendedProduct);
        this.theme.sidebar.toggleExtended(null, false);
      }
    });

    // Update variant info
    this.$body.on('change.vogue-product', '[data-option-input]', event => this._switchVariant(event));
  }

  /**
   * Show the extended details for a product.
   *
   * @param {jQuery} $product
   */
  _openExtendedDetails($product) {
    // Scroll product into view
    const gallery = $product.find('.product-gallery')[0];
    this._ensureElementInViewport(gallery);

    // Animate open the extended details
    $product.find('.product-description-excerpt').revealer('show');

    $product.find('.product-options').slideDown();

    this.theme.sidebar.toggleExtended(() => {
      $product
        .addClass('product-details-extended')
        .find('.product-description-full')
        .revealer('show');

      $product.find('.recommended-products').revealer('show');

      // Create slideshow
      this._createProductSlideshow($product);

      // Set up tab focus loop between details and slideshow,
      // which are in totally separate parts of the DOM.
      $(this.slideshow.el).one('revealer-show', () => {
        const details = $product[0].querySelector('[data-product-details-panel]');
        const focusableDetails = focusable(details);
        const slideshow = this.slideshow.el;
        const focusableSlideshow = focusable(slideshow);
        trapFocus($product[0].querySelector('[data-product-details-panel]'));

        // We use keydown events rather than blur to avoid issues
        // with video/model media, which changes focus and would
        // otherwise trigger these event listeners.
        this.focusCycleDetails = this.events.register(
          focusableDetails[focusableDetails.length - 1],
          'keydown',
          event => {
            if (event.key !== 'Tab') return;
            trapFocus(slideshow);
          },
        );

        this.focusCycleSlideshow = this.events.register(
          focusableSlideshow[focusableSlideshow.length - 1],
          'keydown',
          () => {
            if (event.key !== 'Tab') return;
            trapFocus(details);
          },
        );
      });
    }, true);

    // Resizing the window when a product is extended causes problems
    this.$window.on('resize.vogue-extended-resize', () => {
      this._ensureElementInViewport(gallery, false);
    });
  }

  /**
   * Hide the extend details for a product.
   *
   * @param {jQuery} $product
   */
  _closeExtendedDetails($product) {
    // Remove the slideshow
    this.events.unregister(this.focusCycleDetails);
    this.events.unregister(this.focusCycleSlideshow);
    removeTrapFocus();
    this._destroyProductSlideshow();

    $product.find('.product-options').slideUp();

    $product.find('.recommended-products').revealer('hide');

    // Animate out the extended details
    $product
      .find('.product-description-full')
      .revealer('hide')
      .one('revealer-hide', () => {
        $product
          .removeClass('product-details-extended')
          .find('.product-description-excerpt')
          .revealer('hide');

        this.theme.sidebar.toggleExtended(null, false);
      });

    // Remove the resize handler--it's only needed when the details are extended
    this.$window.off('resize.vogue-extended-resize');
  }

  /**
   * Create a slideshow for the product images when the extended
   * details are opened.
   */
  _createProductSlideshow($product) {
    const clonedGallery = this.products
      .filter(product => product.$el[0] === $product[0])[0].originalGallery.cloneNode(true);

    const $slideshow = $('<div>').addClass('product-slideshow').revealer('hide', true);
    $slideshow[0].appendChild(clonedGallery);

    this.slideshow = {
      el: $slideshow[0],
      productGallery: this._generateProductGallery($slideshow[0], { enableVideoAutoplay: true }),
    };

    this.$body.append($slideshow);

    rimg.watch($slideshow[0]);
    this.slideshow.productGallery.initFlickity();

    // Select first available variant media
    const variant = this._getSelectedProductVariant($product);
    this.slideshow.productGallery.selectMediaByVariant(variant);

    // Show the slideshow
    $slideshow.revealer('show');
  }

  /**
   * Remove the current product slideshow.
   */
  _destroyProductSlideshow() {
    if (!this.slideshow) return;

    const slideshow = this.slideshow.el;
    $(slideshow)
      .revealer('hide')
      .one('revealer-hide', () => {
        this.slideshow.productGallery.unload();
        slideshow.parentNode.removeChild(slideshow);
        this.slideshow = null;
      });
  }

  /**
   * Scroll to a position where the element is completely visible.
   *
   * @param {Element} el
   */
  _ensureElementInViewport(el, animate = true) {
    const productRect = el.getBoundingClientRect();
    const offsetTop = Math.ceil(productRect.top);
    const offsetBottom = Math.ceil(window.innerHeight - productRect.bottom);
    const duration = animate ? 300 : 0;

    if (offsetTop > 0) {
      $('html, body').animate({ scrollTop: `+=${offsetTop}px` }, duration);
    } else if (offsetBottom > 0) {
      $('html, body').animate({ scrollTop: `-=${offsetBottom}px` }, duration);
    }
  }

  _isMobile() {
    return layout.isBreakpoint('XS', 'S');
  }

  _isSingleSidebar(visible = false) {
    return $(`.product-single.${visible ? 'sidebar-always-visible' : 'sidebar-always-hidden'}`).length;
  }

  _isSingleSidebarTablet(visible = false) {
    return this._isSingleSidebar(visible) && layout.isBreakpoint('MS', 'M');
  }

  _isSingleSidebarDesktop(visible = false) {
    return this._isSingleSidebar(visible) && layout.isBreakpoint('L', 'XL');
  }

  _positionTick() {
    if (!this.positionTicking) {
      window.requestAnimationFrame(() => {
        this._updateProductPositions();
        this.positionTicking = false;
      });

      this.positionTicking = true;
    }
  }

  _updateProductPositions() {
    if (this._isSingleSidebarTablet(false) || this._isSingleSidebarDesktop(false) || this._isSingleSidebarDesktop(true)) {
      return;
    }

    const screenHeight = window.innerHeight;
    const screenHeightHalf = screenHeight / 2;
    const $sidebar = $('.product-main-sidebar');
    const $header = $('.product-main-sidebar [data-main-sidebar-header]');
    const sidebarOffset = this._isMobile() ? 0 : this.sidebarWidth;
    // It's necessary to check the sidebar separately from this.hasSidebar
    // to accommodate sections being added and removed in the theme editor
    const sidebarEnabled = window.Theme.hasSidebar;
    const headerHeight = sidebarEnabled
      ? $sidebar.outerHeight()
      : 0;
    const height = screenHeight - headerHeight - (this.gridSpacing * 2);

    // Activate the grid mask if needed (see _sidebar.scss)
    $header.toggleClass('needs-grid-mask', window.scrollY > this.gridSpacing);

    // Position products
    this.products.forEach((product) => {
      const detailsHeight = product.$details.height();
      const productRect = product.$body[0].getBoundingClientRect();
      const pinDetailsToTop = detailsHeight + headerHeight > product.$gallery.height();
      const absLeftOffset = 0;

      // Detect which product we are on, and update the URL to match
      if (productRect.top < screenHeightHalf && productRect.bottom > screenHeightHalf) {
        this._setHistory(product);
      }

      if (this._isMobile() || this._isSingleSidebarTablet(true)) {
        const mobileHeaderHeight = product.$mobileHeader.data('height');
        const galleryRect = product.$gallery[0].getBoundingClientRect();
        const isFloating = (galleryRect.bottom - screenHeight) + mobileHeaderHeight > 0;
        const isInFrame = galleryRect.top - screenHeight < 0;

        // Set desktop position
        product.$details.css({
          position: 'relative',
          top: 'auto',
          left: 'auto',
          bottom: 'auto',
          maxHeight: 'none',
        });

        // Position mobile header
        product.$mobileHeader.toggleClass('is-floating', isFloating);

        product.$mobileHeader.css({
          position: isFloating ? 'fixed' : 'static',
          right: this.gridSpacing,
          bottom: 0,
          left: this.gridSpacing,
          display: isInFrame ? '' : 'none',
        });
      } else if (
        !pinDetailsToTop &&
        productRect.bottom - detailsHeight - (this.gridSpacing * 2) - headerHeight < 0
      ) {
        // Pin to bottom of the product
        product.$details.css({
          position: 'absolute',
          top: 'auto',
          left: -sidebarOffset,
          bottom: this.gridSpacing,
          maxHeight: height,
        });
      } else if (!pinDetailsToTop && productRect.top - headerHeight <= 0) {
        // Pin to the top of the viewport
        product.$details.css({
          position: 'fixed',
          top: headerHeight + this.gridSpacing,
          left: this.gridSpacing,
          bottom: 'auto',
          maxHeight: height,
        });
      } else {
        // Pin to the top of the product
        const topOffset = pinDetailsToTop
          ? Math.min(headerHeight, Math.max(0, headerHeight - productRect.top))
          : 0;

        const leftOffset = $('[data-single-product]').length
          ? absLeftOffset
          : -sidebarOffset;
        product.$details.css({
          position: 'absolute',
          top: this.gridSpacing + topOffset,
          left: leftOffset,
          bottom: 'auto',
          maxHeight: height,
        });
      }
    });
  }

  /**
   * Update the browser's URL to match a specific product URL.
   */
  _setHistory(product) {
    if (!this.enableHistory || !window.history || !window.history.replaceState) {
      return;
    }

    const { productUrl } = product.$details[0].dataset;

    if (window.location.href !== productUrl) {
      // Make sure an exception doesn't crash the whole page
      // For example, Safari throws a `SecurityError` if the URL is updated too often
      try {
        window.history.replaceState({}, '', productUrl);
      } catch (error) {
        console.warn(error);
      }
    }
  }

  _updateUnitPrice(product, variant) {
    const unitPriceEl = product.querySelector('[data-unit-price]');

    if (unitPriceEl && 'unit_price_measurement' in variant) {
      const totalQuantity = unitPriceEl.querySelector('[data-total-quantity]');
      const unitPriceAmount = unitPriceEl.querySelector('[data-unit-price-amount]');
      const unitPriceMeasure = unitPriceEl.querySelector('[data-unit-price-measure]');

      totalQuantity.innerHTML = `${variant.unit_price_measurement.quantity_value}${variant.unit_price_measurement.quantity_unit}`;

      unitPriceAmount.innerHTML = Shopify.formatMoney(variant.unit_price, window.Theme.moneyFormat);

      if (variant.unit_price_measurement.reference_value === 1) {
        unitPriceMeasure.innerHTML = variant.unit_price_measurement.reference_unit;
      } else {
        unitPriceMeasure.innerHTML = `${variant.unit_price_measurement.reference_value}${variant.unit_price_measurement.reference_unit}`;
      }

      if (variant.price > 0) {
        unitPriceEl.classList.remove('product-details__unit-price--hidden');
      } else {
        unitPriceEl.classList.add('product-details__unit-price--hidden');
      }
    } else if (unitPriceEl) {
      unitPriceEl.classList.add('product-details__unit-price--hidden');
    }
  }

  _switchVariant(event) {
    const $input = $(event.currentTarget);
    const $product = $input.parents('.product');

    // Update the selected variant ID
    const variant = this._getSelectedProductVariant($product);
    this._updateProductVariant($product, variant);
    this._updatePrice($product, variant);

    const { paymentTerms, surfacePickUp } = this.products.filter(({ $el }) => $el[0] === $product[0])[0];
    paymentTerms.update(variant.id);
    surfacePickUp.load(variant.id);
  }

  _updateProductVariant($product, variant) {
    // Mark unavailable variants
    $product.toggleClass('product-variant-unavailable', variant.id === null);
    $product.toggleClass('product-variant-soldout', variant.id !== null && !variant.available);

    // Smart payment buttons -- remove the outofstock class since we're handling
    // it through JS now
    $product.find('.product-form').removeClass('product-form-selected-variant-outofstock');

    if (!variant.available) {
      $product.find('.shopify-payment-button').slideUp();
    } else {
      $product.find('.shopify-payment-button').slideDown();
    }

    // Update our select element, which is the source of truth for
    // the currently selected variant
    $product.find('[data-product-variants]').val(variant.id);

    // Focus on variant image
    this._selectVariantImage($product, variant);
  }

  _updatePrice($product, variant) {
    const hasCompareAtPrice = variant.compare_at_price !== null && variant.compare_at_price > variant.price;
    const $productPrice = $product.find('[data-price-original]');
    const $compareAtPrice = $product.find('[data-price-compare]');

    $productPrice.text(Shopify.formatMoney(variant.price, window.Theme.moneyFormat));

    $compareAtPrice.text(Shopify.formatMoney(variant.compare_at_price, window.Theme.moneyFormat))
      .toggleClass('product-price-has-compare', hasCompareAtPrice);

    this._updateUnitPrice($product[0], variant)
  }

  _selectVariantImage($product, variant) {
    if (!variant || !variant.featured_media) return;

    // Grab selected media element
    const $productImage = $product.find(`[data-media="${variant.featured_media.id}"]`);
    if (!$productImage.length) return;

    // Change slideshow slide if we are in mobile
    if (this.slideshow) {
      this.slideshow.productGallery.selectMediaByVariant(variant);
      return;
    }

    if (!(this._isSingleSidebarDesktop(false) || this._isSingleSidebarDesktop(true))) {
      return;
    }

    this._pauseGalleries();

    // Fade out non-selected images
    const $productImages = $product.find('[data-media]');

    $productImages
      .not($productImage)
      .addClass('product-media-fade');

    // Scroll to selected image
    const scrollTop = this._getProductImageScrollPosition($product, $productImage);

    $('html,body').animate({ scrollTop }, 'slow', 'swing', () => {
      // Fade back in all the images
      setTimeout(() => {
        $productImages.removeClass('product-media-fade');
      }, 333);
    });
  }

  _getProductImageScrollPosition($product, $image) {
    const $gallery = $product.find('.product-gallery');

    // Otherwise, scroll to the selected image
    const menuHeight = 0; // this.$menu.height() || 0;

    // Bottom of the image list
    const max = ($gallery.outerHeight()
      + $gallery.offset().top
      + menuHeight)
      - window.innerHeight;

    // Image mid-point
    const imageOffset = ($image.offset().top
      - ((window.innerHeight - menuHeight) / 2))
      + ($image.height() / 2);

    // Don't scroll past the bottom image
    return Math.min(max, imageOffset);
  }

  /**
   * Get the selected variant details for a specific product.
   *
   * @param {jQuery} $product
   * @return {Object} A variant object.
   */
  _getSelectedProductVariant($product) {
    const $inputs = $product.find('[data-option-input]');
    const $select = $product.find('[data-product-variants]');
    const product = $select.data('product');

    // Grab the list of selected options
    const options = {};

    $inputs.filter(':checked').each((index, el) => {
      const $input = $(el);
      const id = $input.data('option-index');
      options[`option${id}`] = $input.val();
    });

    // Grab the variant
    return this._getVariantFromOptions(product, options) || {
      id: null,
      price: 0,
      compare_at_price: null,
      available: false,
    };
  }

  /**
   * Get variant details for a specific set of options.
   *
   * @param {Object} product
   *        A product, as made available from the liquid template.
   *
   * @param {Object} options
   *        A map of option keys to values. One of: option1, option2, option3.
   *
   * @return {Object} A variant object, or `null` if none found.
   */
  _getVariantFromOptions(product, options) {
    if (!product) return null;
    if (!product.variants) return null;

    for (let i = 0; i < product.variants.length; i++) {
      const variant = product.variants[i];
      let isMatch = true;

      const optionKeys = Object.keys(options);

      for (let j = 0; j < optionKeys.length; j++) {
        const optionKey = optionKeys[j];

        if (variant[optionKey] !== options[optionKey]) {
          isMatch = false;
          break;
        }
      }

      if (isMatch) return variant;
    }

    return null;
  }
}
